const get = require('lodash/get')
const {
  getAlertStatus
} = require('./rms-sheet-utils')

const RMSHQCODE = '1000'

// All static headers
const headers = [
  'SN',
  'PRODUCT CODE',
  'PRODUCT NAME',
  'COMMODITY TYPE',
  'CMS HQ',
  'RMS BRANCHES',
  'TOTAL',
  'AMC',
  'ALERT BRANCH',
  'ALERT BRANCHES + HQ',
  'MOS BRANCH',
  'MOS (HQ + BRANCH)'
]

//  Generate future months mos headers
const generateFutureHeaders = (currentDate) => {
  const numberOfMonths = 5
  const futureMonthHeaders = []
  for (let i = 1; i <= numberOfMonths; i++) {
    const futureDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1)
    const monthName = futureDate.toLocaleString('default', { month: 'short' })
    const year = futureDate.getFullYear().toString().slice(-2)
    futureMonthHeaders.push(`${monthName}-${year}`)
  }
  return futureMonthHeaders
}

const generateWarehouseStock = async (api, organisationId, warehouseData, branchCode = null) => {
  const today = new Date()

  const futureMonthHeaders = generateFutureHeaders(today)

  const consumptions = await api.externalForecast.getAmcBySku({
    locationId: RMSHQCODE
  })

  const amcMap = consumptions.reduce((acc, item) => {
    const productId = `product:${item.product_sku.toLowerCase()}`
    acc[productId] = parseFloat(item.consumption) || 0
    return acc
  }, {})

  const productIDs = Object.keys(amcMap)
  const productDocs = await api.product.getByIds(productIDs)

  const stockBySku = warehouseData.reduce((acc, item) => {
    const productId = `product:${item.sku.toLowerCase()}`
    const product = productDocs.find(product => product._id === productId)

    if (!acc[productId]) {
      acc[productId] = {
        sku: item.sku,
        name: get(product, 'fullName', ''),
        commodityType: get(product, 'commodityType', null),
        rmshqStock: 0,
        otherBranchStock: 0
      }
    }

    if (item.source === RMSHQCODE) {
      acc[productId].rmshqStock += item.closing
    } else {
      acc[productId].otherBranchStock += item.closing
    }
    return acc
  }, {})

  const groupedData = Object.values(stockBySku).reduce((acc, item) => {
    const productId = `product:${item.sku.toLowerCase()}`
    const amc = amcMap[productId] || 0

    const totalStock = item.rmshqStock + item.otherBranchStock

    // Calculate Months of Stock (MOS)
    const mosBranch = amc > 0 ? (item.otherBranchStock / amc) : item.otherBranchStock
    const mosTotal = amc > 0 ? (totalStock / amc) : totalStock

    const alertBranch = getAlertStatus(mosBranch)
    const alertTotal = getAlertStatus(mosTotal)

    // Generate future consumption projections
    // By deducting 1 from mos of current month
    const futureMOS = futureMonthHeaders.reduce((acc, header, index) => {
      const mos = Math.floor(mosTotal - (index + 1))
      acc[header] = mos < 0 ? `(${mos})` : mos
      return acc
    }, {})

    const rowData = {
      'SN': 0,
      'PRODUCT CODE': item.sku,
      'PRODUCT NAME': item.name,
      'COMMODITY TYPE': item.commodityType || '',
      'CMS HQ': item.rmshqStock,
      'RMS BRANCHES': item.otherBranchStock,
      'TOTAL': totalStock,
      'AMC': amc,
      'ALERT BRANCH': alertBranch,
      'ALERT BRANCHES + HQ': alertTotal,
      'MOS BRANCH': Math.floor(mosBranch * 10) / 10,
      'MOS (HQ + BRANCH)': Math.floor(mosTotal * 10) / 10,
      ...futureMOS
    }

    if (amc > 0) {
      const commodityType = item.commodityType
      if (commodityType) {
        if (!acc.commodityTypeGroups[commodityType]) {
          acc.commodityTypeGroups[commodityType] = []
        }
        rowData['SN'] = acc.commodityTypeGroups[commodityType].length + 1
        acc.commodityTypeGroups[commodityType].push(rowData)
      } else {
        rowData['SN'] = acc.uncategorized.length + 1
        acc.uncategorized.push(rowData)
      }
    } else {
      rowData['SN'] = acc.zeroAMC.length + 1
      acc.zeroAMC.push(rowData)
    }
    return acc
  }, { commodityTypeGroups: {}, uncategorized: [], zeroAMC: [] })
  const allHeaders = headers.concat(futureMonthHeaders)

  return {
    headers: allHeaders,
    data: {
      commodityTypeGroups: groupedData.commodityTypeGroups,
      uncategorized: groupedData.uncategorized,
      zeroAMC: groupedData.zeroAMC
    },
    futureMonthHeaders
  }
}

module.exports = {
  generateWarehouseStock
}
